module.exports = __webpack_public_path__ + "static/media/beliefs-large@2x.ee0d36e5.png";